export default "<div [@myRouteAnimation]=\"getRouteData(o)\">\n  <router-outlet #o=\"outlet\"></router-outlet>\n</div>\n\n"